import { useState } from 'react'
import { StepUnsavedChanges } from './types'

export const useUnsavedChanges = (activeStepKey: string) => {
  const [unsavedChanges, setUnsavedChanges] = useState<Record<string, StepUnsavedChanges>>({})

  const saveUnsavedChanges = (formValues: StepUnsavedChanges) => {
    setUnsavedChanges(current => ({ ...current, [activeStepKey]: formValues }))
  }

  const removeUnsavedChanges = () => {
    setUnsavedChanges(current => {
      const { [activeStepKey]: removedStepKey, ...otherUnsavedChanges } = current || {}
      return otherUnsavedChanges
    })
  }

  return { unsavedChanges, saveUnsavedChanges, removeUnsavedChanges }
}
